<section
    class="tw-bg-[#F9FAFF] tw-py-10 tw-px-[25px] md:tw-px-[30px] xl:tw-px-0"
>
    <div class="tw-max-w-[1280px] tw-mx-auto tw-items-center">
        <h2
            class="!tw-text-[22px] !tw-w-[285px] md:!tw-w-full md:!tw-text-[28px] tw-text-[#0F3172] !tw-font-bold"
        >
            {{ "DIGITAL_SERVICES.BUKKU.FORM.TITLE" | translate }}
        </h2>
        <p
            class="!tw-text-[#7b7575] !tw-text-[14px] !tw-mb-[30px] !tw-w-[285px] md:!tw-w-full md:!tw-max-w-auto"
        >
            {{ "DIGITAL_SERVICES.BUKKU.FORM.DESCRIPTION" | translate }}
        </p>
        <div class="">
            <form
                [formGroup]="form"
                (ngSubmit)="submitForm()"
                #formContainer
                class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-5"
            >
                <div class="inp-field">
                    <label
                        >{{ "DIGITAL_SERVICES.BUKKU.FORM.NAME" | translate
                        }}<span class="tw-text-red-400 tw-ml-[5px]"
                            >*</span
                        ></label
                    >
                    <input
                        type="text"
                        [placeholder]="
                            'DIGITAL_SERVICES.BUKKU.FORM.PLACEHOLDER.NAME'
                                | translate
                        "
                        formControlName="name"
                        [ngClass]="{
                            'input-error':
                                form.get('name')?.touched &&
                                form.get('name')?.invalid
                        }"
                    />
                    <div
                        class="error"
                        *ngIf="
                            form.get('name')?.touched &&
                            form.get('name')?.errors
                        "
                    >
                        <mat-icon fontSet="material-icons-outlined"
                            >info</mat-icon
                        >

                        <span *ngIf="form.get('name')?.errors?.['required']">
                            {{ "DIGITAL_SERVICES.BUKKU.FORM.NAME" | translate }}
                            {{ "ERROR.IS_REQUIRED" | translate }}
                        </span>
                        <span
                            *ngIf="form.get('name')?.errors?.['minlength'] || form.get('name')?.errors?.['maxlength'] || form.get('name')?.errors?.['pattern']"
                        >
                            {{
                                "DIGITAL_SERVICES.BUKKU.FORM.VALIDATION.NAME"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <div class="inp-field">
                    <label
                        >{{ "DIGITAL_SERVICES.BUKKU.FORM.EMAIL" | translate
                        }}<span class="tw-text-red-400 tw-ml-[5px]"
                            >*</span
                        ></label
                    >
                    <input
                        type="email"
                        [placeholder]="
                            'DIGITAL_SERVICES.BUKKU.FORM.PLACEHOLDER.EMAIL'
                                | translate
                        "
                        formControlName="email"
                        [ngClass]="{
                            'input-error':
                                form.get('email')?.touched &&
                                form.get('email')?.invalid
                        }"
                    />
                    <div
                        class="error"
                        *ngIf="
                            form.get('email')?.touched &&
                            form.get('email')?.errors
                        "
                    >
                        <mat-icon fontSet="material-icons-outlined"
                            >info</mat-icon
                        >

                        <span *ngIf="form.get('email')?.errors?.['required']">
                            {{
                                "DIGITAL_SERVICES.BUKKU.FORM.EMAIL" | translate
                            }}
                            {{ "ERROR.IS_REQUIRED" | translate }}
                        </span>

                        <span *ngIf="form.get('email')?.errors?.['pattern']">
                            {{
                                "DIGITAL_SERVICES.BUKKU.FORM.VALIDATION.EMAIL"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <div class="inp-field">
                    <label
                        >{{ "DIGITAL_SERVICES.BUKKU.FORM.PHONE" | translate
                        }}<span class="tw-text-red-400 tw-ml-[5px]"
                            >*</span
                        ></label
                    >
                    <div class="tw-w-full tw-relative">
                        <div
                            class="tw-bg-[#F9FAFF] tw-border tw-border-[#D8D8D8] tw-w-[100px] tw-absolute tw-left-0 tw-h-full tw-flex tw-items-center tw-justify-center tw-rounded-l-[16px]"
                        >
                            +60
                        </div>
                        <input
                            type="text"
                            [placeholder]="
                                'DIGITAL_SERVICES.BUKKU.FORM.PLACEHOLDER.PHONE'
                                    | translate
                            "
                            formControlName="phoneNumber"
                            [ngClass]="{
                                'input-error':
                                    form.get('phoneNumber')?.touched &&
                                    form.get('phoneNumber')?.invalid
                            }"
                            class="tw-w-full !tw-pl-[105px]"
                            (keypress)="allowNumbers($event)"
                        />
                    </div>
                    <div
                        class="error"
                        *ngIf="
                            form.get('phoneNumber')?.touched &&
                            form.get('phoneNumber')?.errors
                        "
                    >
                        <mat-icon fontSet="material-icons-outlined"
                            >info</mat-icon
                        >

                        <span
                            *ngIf="form.get('phoneNumber')?.errors?.['required']"
                        >
                            {{
                                "DIGITAL_SERVICES.BUKKU.FORM.PHONE" | translate
                            }}
                            {{ "ERROR.IS_REQUIRED" | translate }}
                        </span>

                        <span
                            *ngIf="form.get('phoneNumber')?.errors?.['pattern']"
                        >
                            {{
                                "DIGITAL_SERVICES.BUKKU.FORM.VALIDATION.PHONE"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <div class="inp-field">
                    <label
                        >{{
                            "DIGITAL_SERVICES.BUKKU.FORM.COMPANY_NAME"
                                | translate
                        }}<span class="tw-text-red-400 tw-ml-[5px]"
                            >*</span
                        ></label
                    >
                    <input
                        type="text"
                        [placeholder]="
                            'DIGITAL_SERVICES.BUKKU.FORM.PLACEHOLDER.COMPANY_NAME'
                                | translate
                        "
                        formControlName="companyName"
                        [ngClass]="{
                            'input-error':
                                form.get('companyName')?.touched &&
                                form.get('companyName')?.invalid
                        }"
                    />
                    <div
                        class="error"
                        *ngIf="
                            form.get('companyName')?.touched &&
                            form.get('companyName')?.errors
                        "
                    >
                        <mat-icon fontSet="material-icons-outlined"
                            >info</mat-icon
                        >

                        <span
                            *ngIf="form.get('companyName')?.errors?.['required']"
                        >
                            {{
                                "DIGITAL_SERVICES.BUKKU.FORM.COMPANY_NAME"
                                    | translate
                            }}
                            {{ "ERROR.IS_REQUIRED" | translate }}
                        </span>

                        <span
                            *ngIf="form.get('companyName')?.errors?.['pattern'] || form.get('companyName')?.errors?.['maxLength']"
                        >
                            {{
                                "DIGITAL_SERVICES.BUKKU.FORM.VALIDATION.COMPANY"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
                <div class="inp-field">
                    <label>{{
                        "DIGITAL_SERVICES.BUKKU.FORM.MESSAGE" | translate
                    }}</label>
                    <textarea
                        class="tw-h-[115px]"
                        maxlength="1000"
                        [placeholder]="
                            'DIGITAL_SERVICES.BUKKU.FORM.PLACEHOLDER.MESSAGE'
                                | translate
                        "
                        formControlName="message"
                        [ngClass]="{
                            'input-error':
                                form.get('message')?.touched &&
                                form.get('message')?.invalid
                        }"
                    ></textarea>
                    <div
                        class="error"
                        *ngIf="
                            form.get('message')?.touched &&
                            form.get('message')?.invalid
                        "
                    >
                        <mat-icon fontSet="material-icons-outlined"
                            >info</mat-icon
                        >
                        {{
                            "DIGITAL_SERVICES.BUKKU.FORM.VALIDATION.MESSAGE"
                                | translate
                        }}
                    </div>
                </div>

                <div>
                    <div class="tw-flex tw-gap-[5px] tw-items-start md:tw-mt-6">
                        <input
                            class="tw-accent-[#4B6EEC] tw-h-[18px] tw-w-[18px]"
                            type="checkbox"
                            formControlName="termsConditions"
                        />
                        <span
                            class="tw-text-[14px] tw-text-[#7B7575]"
                            [innerHTML]="
                                'DIGITAL_SERVICES.BUKKU.PRIVACY' | translate
                            "
                            ><span class="tw-text-red-400 tw-ml-[5px]"
                                >*</span
                            ></span
                        >
                    </div>
                    <div
                        class="error !tw-ml-[15px] !tw-mt-[7px]"
                        *ngIf="
                            form.get('termsConditions')?.touched &&
                            form.get('termsConditions')?.invalid
                        "
                    >
                        <mat-icon fontSet="material-icons-outlined"
                            >info</mat-icon
                        >

                        {{
                            "DIGITAL_SERVICES.BUKKU.FORM.VALIDATION.TERMS"
                                | translate
                        }}
                    </div>
                </div>
                <div class=""></div>
                <button
                    [disabled]="isLoading"
                    ga-event-id="submit_bukku_button_click"
                    ga-event-category="Bukku Button"
                    ga-event-label="Submit Bukku Button Click"
                    ga-track="track"
                    class="disabled:tw-opacity-70 tw-bg-[#4B6EEC] tw-text-white tw-rounded-full md:tw-max-w-fit tw-px-[100px] tw-py-[13px]"
                    type="submit"
                >
                    {{ selectedLanguage === "en" ? "Submit" : "Hantar" }}
                </button>
            </form>
        </div>
    </div>
</section>
